'use client'

import { createContext, useContext, useState } from 'react'

interface IntegrationsModalContextType {
  isOpen: boolean
  openIntegrationsModal: () => void
  closeIntegrationsModal: () => void
}

const IntegrationsModalContext = createContext<IntegrationsModalContextType | undefined>(undefined)

export function IntegrationsModalProvider({ children }: { children: React.ReactNode }) {
  const [isOpen, setIsOpen] = useState(false)

  const openIntegrationsModal = () => setIsOpen(true)
  const closeIntegrationsModal = () => setIsOpen(false)

  const value: IntegrationsModalContextType = {
    isOpen,
    openIntegrationsModal,
    closeIntegrationsModal,
  }

  return (
    <IntegrationsModalContext.Provider value={value}>{children}</IntegrationsModalContext.Provider>
  )
}

export function useIntegrationsModal() {
  const context = useContext(IntegrationsModalContext)
  if (context === undefined) {
    throw new Error('useIntegrationsModal must be used within an IntegrationsModalProvider')
  }
  return context
}
